const changesetFields = [
  'salutation',
  'firstname',
  'lastname',
  'email',
  'organizationMemberships[organizationId]_phone',
  'organizationMemberships[organizationId]_department',
  'organizationMemberships[organizationId]_position',
  'organizationMemberships[organizationId]_address_street',
  'organizationMemberships[organizationId]_address_streetNumber',
  'organizationMemberships[organizationId]_address_city',
  'organizationMemberships[organizationId]_address_countryCode',
  'language',
  'organizationMemberships[organizationId]_userOrganizationStatus',
  'organizationId_group',
  'organizationId_role',
  'role',
  'skipMfa',
] as const;
export type UserChangeSetFields = (typeof changesetFields)[number];

const displayFields: Record<UserChangeSetFields, string> = {
  salutation: 'user.salutation.label',
  firstname: 'user.firstname.label',
  lastname: 'user.lastname.label',
  email: 'user.email.label',
  'organizationMemberships[organizationId]_phone': 'user.phone.label',
  'organizationMemberships[organizationId]_department': 'user.department',
  'organizationMemberships[organizationId]_position': 'user.position',
  'organizationMemberships[organizationId]_address_street': 'address.street',
  'organizationMemberships[organizationId]_address_streetNumber': 'address.streetNumber',
  'organizationMemberships[organizationId]_address_city': 'address.city',
  'organizationMemberships[organizationId]_address_countryCode': 'address.country',
  language: 'user.language.label',
  'organizationMemberships[organizationId]_userOrganizationStatus': 'user.organization.status',
  organizationId_group: 'common.groups',
  organizationId_role: 'common.roles',
  role: 'user.organization.role',
  skipMfa: 'user.skipMfa',
};
const translatableValues: Partial<Record<UserChangeSetFields, string>> = {
  salutation: 'user.salutation',
  'organizationMemberships[organizationId]_department': 'register.user.departmentOptions',
  'organizationMemberships[organizationId]_userOrganizationStatus': 'organization.users.status',
};
const isoValues: Partial<Record<UserChangeSetFields, string>> = {
  'organizationMemberships[organizationId]_address_countryCode': 'region',
  language: 'language',
};

export const UserTransformerOptions = {
  displayFields,
  translatableValues,
  isoValues,
};
